import { Operator } from '@app/shared/models/contracts/enums/shared-enums';
import { enumToOptions } from '@app/shared/helpers';

export const OPERATOR_OPTIONS = enumToOptions(Operator);
